export default "__VITE_ASSET__78752bfb__"